var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7608 2.93218C12.7608 2.75745 12.6101 2.6158 12.4242 2.6158H4.51321C4.32729 2.6158 4.17657 2.75745 4.17657 2.93218L4.17657 3.40675C4.17657 3.58148 4.32729 3.72312 4.51321 3.72312H12.4242C12.6101 3.72312 12.7608 3.58148 12.7608 3.40675V2.93218ZM4.17657 1.66667C3.61881 1.66667 3.16666 2.09161 3.16666 2.6158V3.72312C3.16666 4.07444 3.36975 4.38117 3.67161 4.54528V5.93776V6.7287V13.226C3.67161 13.8376 4.19913 14.3333 4.84984 14.3333H12.0876C12.7383 14.3333 13.2658 13.8376 13.2658 13.226V6.7287V5.93776V4.55108C13.5461 4.39968 13.7222 4.11791 13.7222 3.77165V2.66433C13.7222 2.14014 13.3186 1.66667 12.7608 1.66667H4.17657ZM12.2559 5.93776V4.67225H4.68153V5.93776H12.2559ZM4.68153 6.7287V13.226C4.68153 13.3134 4.75688 13.3842 4.84984 13.3842H12.0876C12.1805 13.3842 12.2559 13.3134 12.2559 13.226V6.7287H4.68153ZM9.08417 10.7607C9.43748 10.7607 9.7239 10.4577 9.7239 10.0841C9.7239 9.71035 9.43748 9.40741 9.08417 9.40741C8.73085 9.40741 8.44443 9.71035 8.44443 10.0841C8.44443 10.4577 8.73085 10.7607 9.08417 10.7607ZM10.2357 12.9259C10.801 12.9259 11.2592 12.4412 11.2592 11.8433C11.2592 11.2454 10.801 10.7607 10.2357 10.7607C9.67038 10.7607 9.21211 11.2454 9.21211 11.8433C9.21211 12.4412 9.67038 12.9259 10.2357 12.9259Z",
    fill: "#1C3863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.03c62bc96776bd07cb2bd19c6a6ba280.svg";
export { ForwardRef as ReactComponent };